import {
  ApiGetRequest,
  ApiPutRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiBlobGetRequest,
  // ApiDeleteRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Pembayaran Piutang',
    title_giro: 'Giro Masuk',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Daftar Piutang',
        href: '/adm/fin/penjualan/piutang-usaha',
        active: true,
      },
    ],
    breadcrumb_giro: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Daftar Giro Masuk',
        href: '/adm/fin/kas-bank/giro-masuk',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields: [
      {
        key: 'code_pay',
        label: 'Kode',
      },
      {
        key: 'tgl_bayar',
        label: 'Tanggal',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'memo',
        label: 'Keterangan',
      },
      {
        key: 'total_pembayaran',
        label: 'Nilai',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_giro: [
      {
        key: 'tgl_bayar',
        label: 'Tanggal',
      },
      {
        key: 'giro_bank',
        label: 'Nama Bank',
      },
      {
        key: 'giro_no',
        label: 'No Cek',
      },
      {
        key: 'giro_due_date',
        label: 'Jatuh Tempo',
      },
      {
        key: 'principle',
        label: 'Dari',
      },
      {
        key: 'code_pay',
        label: 'No Ref',
      },
      {
        key: 'total_pembayaran',
        label: 'Nilai',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_invoice: [
      {
        key: 'code_invoice',
        label: 'Kode',
      },
      {
        key: 'tgl_invoice',
        label: 'Tanggal',
      },
      {
        key: 'inv_type',
        label: 'Tipe',
      },
      {
        key: 'term_payment',
        label: 'Term Payment',
      },
      {
        key: 'total_piutang',
        label: 'Total Piutang',
      },
    ],
    id_principle: false,
    form: {
      acc_cash: '',
      acc_cash_code: '',
      acc_cash_name: '',
      id_principle: '',
      principle_name: '',
      tgl_bayar: '',
      id_department: '',
      use_giro: '',
      memo: '',
      acc_denda: '',
      denda: '',
      total_pembayaran: '',
      items: [
        {
          id_bayar_piutang: '',
          item_invoice: '',
          inv_type: '',
          item_acc_disc: '',
          item_disc: '',
          item_acc_bayar: '',
          item_bayar: '',
        },
      ],
    },
    journal: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeBayarPiutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async pencairanGiroPiutang({ commit, dispatch }, payload = null) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `fin/pembayaran-piutang/${payload.id}/pencairan-giro`
    );

    commit('changeBayarPiutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getListInvoice({ commit, state }) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: data.form ? data.form.id_principle : '',
      id_currency: data.id_currency || '',
    };

    let result = await ApiGetRequest(`fin/pembayaran-piutang/invoice`, params);
    commit('changeBayarPiutang', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getJournal({ commit }, payload = null) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `fin/pembayaran-piutang/${payload.id}/journal`
    );
    commit('changeBayarPiutang', {
      loading: false,
    });

    if (!result.error) {
      commit('changeBayarPiutang', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getListBayarPiutang({ commit, state }, payload = {}) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      use_giro: data.use_giro ? 1 : 0,
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/pembayaran-piutang`, params);
      commit('changeBayarPiutang', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_bayar_piutang.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/pembayaran-piutang`, params);
      commit('changeBayarPiutang', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailBayarPiutang({ commit, state }, payload = null) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/pembayaran-piutang/${payload.id}`);
    commit('changeBayarPiutang', {
      detail: !result.error ? result.data.object : {},
      form: {
        ...data.form,
        ...result.data.object,
        tgl_bayar: result.data.object.tgl_bayar
          ? moment(result.data.object.tgl_bayar).format('DD/MM/YYYY')
          : moment().format('DD/MM/YYYY'),
        doc_date: result.data.object.doc_date
          ? moment(result.data.object.doc_date).format('DD/MM/YYYY')
          : '',
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createBayarPiutang({ commit, state, dispatch }) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/pembayaran-piutang', data.form);
    commit('changeBayarPiutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateBayarPiutang({ commit, state, dispatch }, payload = null) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `fin/pembayaran-piutang/${payload.id}`,
      data.form
    );

    commit('changeBayarPiutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteBayarPiutang({ commit, dispatch }, payload = null) {
    commit('changeBayarPiutang', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/pembayaran-piutang/${payload.id}`);
    commit('changeBayarPiutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
